import ApiService from "@/services/api.service"

export const WarehouseService = {
  getDocument(id) {
    return ApiService.get(`warehouse/document/${id}`)
  },
  addDocumentItem(document_id, params) {
    return ApiService.post(`warehouse/document/${document_id}/operation/add`, params)
  },
  addInventarizationItem(document_id, params) {
    return ApiService.post(`warehouse/document/${document_id}/operation/add/inventarization`, params)
  },
  autoFillInventarization(document_id, params) {
    return ApiService.post(`warehouse/document/${document_id}/operation/fill`, params)
  },
  saveDocument(document_id, items, inventarization = false) {
    return ApiService.post(`warehouse/document/${document_id}/operation/sync${inventarization ? '/inventarization' : '' }`, { items })
  },
  approveDocument(document_id) {
    return ApiService.post(`warehouse/document/${document_id}/approve`)
  },
  cancelDocument(document_id) {
    return ApiService.post(`warehouse/document/${document_id}/cancel`)
  },
  deleteDocumentItem(document_id, item_id) {
    return ApiService.post(`warehouse/document/${document_id}/operation/${item_id}/delete`)
  },
  deleteInventarizationItem(document_id, item_id) {
    return ApiService.post(`warehouse/document/${document_id}/operation/${item_id}/delete/inventarization`)
  },
  materialStocksExcel(material_id) {
    return ApiService.post(`warehouse/material/${material_id}/stocks/excel`)
  },
  getCategoriesWithMaterials() {
    return ApiService.get(`warehouse/categories_with_materials`)
  },
  getMaterialLastPrice(material_id) {
    return ApiService.get(`warehouse/material/${material_id}/price/last`)
  }
}
